// API URL configuration with production fallback
export const getApiUrl = () => {
  if (process.env.REACT_APP_BACKEND_URL) {
    return `${process.env.REACT_APP_BACKEND_URL}/api`;
  }
  // Production fallback for mylms.in - use custom API domain
  if (typeof window !== 'undefined' && window.location.hostname === 'mylms.in') {
    return 'https://api.mylms.in/api';
  }
  // Default for local development
  return '/api';
};

export const getBackendUrl = () => {
  if (process.env.REACT_APP_BACKEND_URL) {
    return process.env.REACT_APP_BACKEND_URL;
  }
  // Production fallback for mylms.in - use custom API domain
  if (typeof window !== 'undefined' && window.location.hostname === 'mylms.in') {
    return 'https://api.mylms.in';
  }
  // Default for local development
  return '';
};

export const API_URL = getApiUrl();
export const BACKEND_URL = getBackendUrl();
